import { IManageActionProps } from "../DocumentTableInterfaces";
import "../css/DocumentTable.css";
import { ChangeApplicabilityState } from "../../../../routing/RoutingStates";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { faCogs } from "@fortawesome/free-solid-svg-icons";

export default function ManageAction({
  document,
  isAdvancedUser,
}: IManageActionProps) {
  const disabled = !isAdvancedUser;
  const navigate = useNavigate();
  const handleNavigationClick = (row: any) => {
    const changeApplicabilityState: ChangeApplicabilityState = {
      document: document,
    };
    navigate("ChangeApplicabilityLevel", {
      state: { changeApplicabilityState },
    });
  };
  return (
    <Button id={`mainPageKey-manage-${document.documentReference}`}
            title="Change Applicability Level"
            onClick={() => handleNavigationClick(document)}
            disabled={disabled}
            className={`${disabled ? "" : "pointer"} btn-xs ms-1 btn-light`}>
      <FontAwesomeIcon icon={faCogs}/>
    </Button>
  );
}
